
import React from 'react';
import './Bulbhousings.css';
import Productinfor from '../../../imgs/Bulbhousing.webp';

const Bulbhousings = () => {
    return (
        <div className="Bulbhous-wrapper">
            <h2>Product Information</h2>
            <div className="Bulbhous-card">
                <img src={Productinfor} alt="Application" className="Bulbhous-img" />
            </div>
        </div>
    );
};

export default Bulbhousings;
